import React from 'react';
import Skeleton from 'react-loading-skeleton';

function HeaderUserSkeleton() {
  return <Skeleton borderRadius={30} className="h-[var(--height-comp)]" />;
}

export default HeaderUserSkeleton;
